import { createAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { LoadGoalsSelectedGoal } from '../model/load-goals-selected.model';

export interface FocusSelectorUpdateSelectedGoal {
    metricId: number;
    updates: LoadGoalsSelectedGoal;
}

export const focusSelectorUpdateSelectedGoal = createAction<
    ActionType,
    FocusSelectorUpdateSelectedGoal
>(ActionType.COACHING_FOCUS_SELECTOR__UPDATE_SELECTED_GOAL);
